<template>
  <div role="button" class="space-y-3" @click="handleBlockClick">
    <DirectFlightsAirlineHeader
      :airline="group.airline"
      :min-price="group.minPrice"
    />
    <div class="space-y-2">
      <DirectFlightsGroupDay
        v-for="(day, dayIndex) in group.days"
        :key="day.date"
        :day="day"
        :day-index="dayIndex"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import DirectFlightsAirlineHeader from './DirectFlightsAirlineHeader.vue';
  import DirectFlightsGroupDay from './DirectFlightsGroupDay.vue';
  import type { DirectFlightGroup } from '../types';

  const props = defineProps<{
    group: DirectFlightGroup;
  }>();

  const emit = defineEmits<{
    onGroupClick: [DirectFlightGroup];
  }>();

  const handleBlockClick = () => {
    if (props.group.offers.length > 0) {
      emit('onGroupClick', props.group);
    }
  };
</script>
